/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unescaped-entities */
import { IRListItem } from '@rhybus/api'
/* eslint-disable no-case-declarations */
import React, { useContext, useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../../assets/ts/api/mpf-r-lists-http'
import { convertDate } from '../../../../../assets/ts/date-and-time/date-and-time'
import Buttons from '../../../../../components/buttons/buttons'
import FileUpload from '../../../../../components/file-upload/file-upload'
import {
  MetadataContext,
  MetadataContextInterface,
} from '../../../../../store/metadata-context-provider'
import {
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
  SELECT_LABEL,
} from '../../../../../utils/constants/global-constants'
import CustomSelect from '../../../../../utils/controls/custom-select'
import {
  optionsTypes,
} from '../../../../../utils/controls/select-options-data'
import '../calendar.css'
import './AddEvent.css'
import RecurrencePattern from './recurrence-pattern'

interface AttachmentFile {
  content: any
  name: string
}
interface EventHours {
  ID: number
  label: string
  value: string
}
interface EventData {
  Category: string | string[]
  Description: string
  EndDate: string
  IsAllDayEvent: boolean
  IsArchived: boolean | string
  Location: string
  Recurrence: boolean | string
  StartDate: string
  rrule: Record<string, any> | any | string
  title: string
}

interface RRuleTime {
  dtstartTime: string
  untilTime: string
}
interface RRule {
  bymonth?: number
  bymonthday?: number
  bysetpos?: number
  byweekday?: string[]
  dtstart: string
  freq: string
  interval?: null | number
  until: string
}

interface OneTimeRule {
  dtstart: string
  freq: string
  until: string
}

interface CalendarList {
  EndDate: string
  EventDate: string
  Id: number
  Title: string
}

interface Props {
  calendarList?: CalendarList
  closeAfterSubmit: () => void
  editEvent?: any
  eventRRule?: any
  findServicingOrganization: any
  isEdit?: boolean
  onClose: () => void
  onDelete: () => void
  sendRefresh: () => void
  setShowAlert: any
  userAssignComponent: any
  userMAJCOM: any
  userSections: any
  userServicingOrganization: any
}

const AddEventForm = (props: Props) => {
  const metadataContext = useContext(MetadataContext)
  const [majcomOptions, setMajcomOptions] = useState<Array<optionsTypes>>(props.userMAJCOM)
  const [servicingOrganizationOptions, setServicingOrganizationOptions] = useState(
    props.userServicingOrganization
  )

  const [existingEvent, setExistingEvent] = useState()
  const [eventTitle, setEventTitle] = useState('')
  const [eventLocation, setEventLocation] = useState('')
  const [eventDescription, setEventDescrtiption] = useState('')
  const [eventHoursStart, setEventHoursStart] = useState('T00:')
  const [eventMinutesStart, setEventMinutesStart] = useState('00:00')
  const [eventHoursEnd, setEventHoursEnd] = useState('T00:')
  const [eventMinutesEnd, setEventMinutesEnd] = useState('00:00')

  const [fileError, setFileError] = useState(false)
  const [isAllDayEvent, setIsAllDayEvent] = useState(false)
  const [recurrence, setRecurrence] = useState(false)
  const [replaceFile, setReplaceFile] = useState(false)
  const [activateEdit, setActivateEdit] = useState(true)
  const [startingDate, setStartingDate] = useState()
  const [endingDate, setEndingDate] = useState()
  const [eventCategoryFilter, setEventCategoryFilter] = useState('Select')
  const [sectionValue, setsectionValue] = useState(ALL_SELECT_VALUE)
  const [servicingOrganizationValue, setservicingOrganizationValue] =
    useState(ALL_SELECT_VALUE_STRING)
  const [servicingmajcomValue, setservicingmajcomValue] = useState(ALL_SELECT_VALUE)
  const [assignedcomponentValue, setassignedcomponentValue] = useState(ALL_SELECT_VALUE)
  const [files, setFiles] = useState([])
  const [ownCategoryValue, setOwnCategoryValue] = useState('')
  const [eventCategory, setEventCategory] = useState('')
  const [, setCalendarList] = useState()
  const [rruleTime, setRRuleTime] = useState({
    dtstartTime: '',
    untilTime: '',
  })
  const [rrule, setRRule] = useState({
    dtstart: '',
    freq: '',
    until: '',
  })
  const [oneTimeRule, setOneTimeRule] = useState({
    dtstart: '',
    freq: '',
    until: '',
  })
  const [calendarEvent, setCalendarEvent] = useState({
    AssignedComponentCode: null,
    Category: [] || '',
    Description: '',
    EndDate: '',
    IsAllDayEvent: false,
    IsArchived: '',
    Location: '',
    MAJCOMCode: null,
    RRule: {},
    Recurrence: false,
    SectionCode: null,
    ServicingOrganization: '',
    StartDate: '',
    Title: '',
  })
  const [filteredHoursList, setFilteredHoursList] = useState()
  const [patternError, setPatternError] = useState('')
  const [titleError, setTitleError] = useState('')
  const [startDateError, setStartDateError] = useState('')
  const [endDateError, setEndDateError] = useState('')
  const [errorFixMessage, setErrorFixMessage] = useState('')
  const [rangeError, setRangeError] = useState('')
  const [assignedCompError, setAssignedCompError] = useState(false)
  const [servicingMAJCOMError, setServicingMAJCOMError] = useState(false)
  const [servicingOrgError, setServicingOrgError] = useState(false)
  const [sectionError, setSectionError] = useState(false)
  const [eventCategoryError, setEventCategoryError] = useState(false)
  const [specifyOwnValueError, setSpecifyOwnValue] = useState('')
  const listName = 'CalendarList'
  const eventHoursList = [
    { ID: 0, label: '12 AM', value: 'T00:' },
    { ID: 1, label: '1 AM', value: 'T01:' },
    { ID: 2, label: '2 AM', value: 'T02:' },
    { ID: 3, label: '3 AM', value: 'T03:' },
    { ID: 4, label: '4 AM', value: 'T04:' },
    { ID: 5, label: '5 AM', value: 'T05:' },
    { ID: 6, label: '6 AM', value: 'T06:' },
    { ID: 7, label: '7 AM', value: 'T07:' },
    { ID: 8, label: '8 AM', value: 'T08:' },
    { ID: 9, label: '9 AM', value: 'T09:' },
    { ID: 10, label: '10 AM', value: 'T10:' },
    { ID: 11, label: '11 AM', value: 'T11:' },
    { ID: 12, label: '12 PM', value: 'T12:' },
    { ID: 13, label: '1 PM', value: 'T13:' },
    { ID: 14, label: '2 PM', value: 'T14:' },
    { ID: 15, label: '3 PM', value: 'T15:' },
    { ID: 16, label: '4 PM', value: 'T16:' },
    { ID: 17, label: '5 PM', value: 'T17:' },
    { ID: 18, label: '6 PM', value: 'T18:' },
    { ID: 19, label: '7 PM', value: 'T19:' },
    { ID: 20, label: '8 PM', value: 'T20:' },
    { ID: 21, label: '9 PM', value: 'T21:' },
    { ID: 22, label: '10 PM', value: 'T22:' },
    { ID: 23, label: '11 PM', value: 'T23:' },
  ]
  const eventMinutesList = [
    { ID: 0, label: '00', value: '00:00' },
    { ID: 1, label: '05', value: '05:00' },
    { ID: 2, label: '10', value: '10:00' },
    { ID: 3, label: '15', value: '15:00' },
    { ID: 4, label: '20', value: '20:00' },
    { ID: 5, label: '25', value: '25:00' },
    { ID: 6, label: '30', value: '30:00' },
    { ID: 7, label: '35', value: '35:00' },
    { ID: 8, label: '40', value: '40:00' },
    { ID: 9, label: '45', value: '45:00' },
    { ID: 10, label: '50', value: '50:00' },
    { ID: 11, label: '55', value: '55:00' },
  ]
  const eventCategories = [
    { ID: 0, label: 'Select Event Category', value: '' },
    { ID: 1, label: 'Meeting', value: 'Meeting' },
    { ID: 2, label: 'Trainings', value: 'Trainings' },
    { ID: 3, label: 'Events', value: 'Events' },
    // { ID: 1, label: 'Meeting', value: 'Meeting' },
    // { ID: 2, label: 'Work Hours', value: 'Work Hours' },
    // { ID: 3, label: 'Business', value: 'Business' },
    // { ID: 4, label: 'Holiday', value: 'Holiday' },
    // { ID: 5, label: 'Get Together', value: 'Get Together' },
  ]
  const isRecurringEvent = (rule: any | undefined): boolean => {
    rule = rule && JSON?.parse(rule)
    return rule?.count > 1 || rule?.byweekday?.length > 0 || rule?.interval || rule?.bysetpos
  }

  const findOrg = (metaData: MetadataContextInterface, majcom: string) => {
    const organizations = metaData.pascodeMetadata
      .filter((org) => org.ServicingMAJCOM === majcom)
      .map((e) => ({ label: e.ServicingOrganization, value: e.ServicingOrganization }))
    // Use a Set to track unique labels
    const uniqueLabels = new Set()
    const uniqueOrganizations = organizations.filter((org) => {
      if (uniqueLabels.has(org.label)) {
        return false
      } else {
        uniqueLabels.add(org.label)
        return true
      }
    })
    return [...[ALL_SELECT_OPTION], ...uniqueOrganizations]
  }
  const findMAJCOM = (metaData: MetadataContextInterface, servOrgCode: number) => {
    const majcoms = metaData.majcoms
      .filter((majcom) => majcom.ParentComponentCode === servOrgCode)
      .map((e) => ({ label: e.Label, value: e.MAJCOMCode }))

    // Use a Set to track unique labels
    const uniqueLabels = new Set()
    const uniqueMAJOMS = majcoms.filter((org) => {
      if (uniqueLabels.has(org.label)) {
        return false
      } else {
        uniqueLabels.add(org.label)
        return true
      }
    })
    return uniqueMAJOMS
  }

  const changeAssignedComponent = ({ value }) => {
    setassignedcomponentValue(value)
    setAssignedCompError(false)

    if (value === 143 || value === -1) {
      setservicingmajcomValue(-1)
      setMajcomOptions([ALL_SELECT_OPTION])
    } else {
      setservicingmajcomValue(-1)
      setMajcomOptions(findMAJCOM(metadataContext, value))
    }
    setServicingOrganizationOptions([ALL_SELECT_OPTION_STRING])
    setservicingOrganizationValue('All')
  }
  const todayDate = new Date().toISOString().split('T')[0]

  const eventHoursOptions = filteredHoursList?.map((e) => {
    return (
      <option key={e.ID} value={e.value}>
        {e.label}
      </option>
    )
  })
  const eventMinuteOptions = eventMinutesList?.map((e) => {
    return (
      <option key={e.ID} value={e.value}>
        {e.label}
      </option>
    )
  })
  //SELECT_OPTION,
  const eventCategoryOptions = [
    ...eventCategories.map((category) => ({
      label: category.label,
      value: category.value,
    })),
  ]
  const hoursStartChangeHandler = (event) => {
    setEventHoursStart(event.target.value)
    setEndDateError('')
  }
  const minutesStartChangeHandler = (event) => {
    setEventMinutesStart(event.target.value)
    setEndDateError('')
  }
  const hoursEndChangeHandler = (event) => {
    setEventHoursEnd(event.target.value)
    setEndDateError('')
  }
  const minutesEndChangeHandler = (event) => {
    setEventMinutesEnd(event.target.value)
    setEndDateError('')
  }
  const startDateSelectHandler = (event: any) => {
    setStartingDate(event.target.value)
    setStartDateError('')
    setErrorFixMessage('')
  }
  const endDateSelectHandler = (event: any) => {
    setEndingDate(event.target.value)
    setEndDateError('')
    setErrorFixMessage('')
  }
  const allDaySelectHandler = () => {
    setIsAllDayEvent(!isAllDayEvent)
  }

  const titleInputHandler = (event) => {
    setEventTitle(event.target.value)
    setTitleError('')
    setErrorFixMessage('')
  }
  const locationInputHandler = (event) => setEventLocation(event.target.value)
  const recurringEventHandler = () => setRecurrence(!recurrence)
  const descriptionHandler = (event) => setEventDescrtiption(event.target.value)
  const eventCategoryChangeHandler = (event) => {
    setEventCategoryFilter(event.value)
    setEventCategoryError(false)
  }
  const sectionChangeHandler = (event) => {
    setsectionValue(event.value)
    setSectionError(false)
  }
  const specifyOwnValueHandler = (event) => {
    setOwnCategoryValue(event.target.value)
    setSpecifyOwnValue('')
  }

  const getRRule = (val: any) => {
    setRRule(val)
  }
  const eventCategoryHandler = (input: any) => {
    setEventCategoryError(false)
    setSpecifyOwnValue('')
    switch (input) {
      case 0:
        setEventCategory('selectEventCategory')
        const specifyOwnValueInput = document.getElementById(
          'specifyOwnValueInput'
        ) as HTMLInputElement | null
        if (specifyOwnValueInput) {
          specifyOwnValueInput.value = ''
        }
        setOwnCategoryValue('')
        break
      case 1:
        setEventCategory('specifyOwnValue')
        const eventCategoriesDropdown = document.getElementById(
          'eventCategoriesDropdown'
        ) as HTMLSelectElement | null
        if (eventCategoriesDropdown) {
          eventCategoriesDropdown.value = ''
        }
        setEventCategoryFilter(undefined)
        break
      default:
        break
    }
  }

  let errorCount: any

  const validationCheck = () => {
    errorCount = 0
    const currentDate = convertDate(new Date(),'dateInput')
    if (calendarEvent.Title.trim() === '') {
      setTitleError('Please enter a title.')
      errorCount++
    }
    if (!recurrence) {
      if (calendarEvent.RRule.dtstart === 'undefinedT00:00:00') {
        setStartDateError('You must specify a value for this required field.')
        errorCount++
      }
      if (calendarEvent.RRule.until === 'undefinedT00:00:00') {
        setEndDateError('You must specify a value for this required field.')
        errorCount++
      }
      if (startingDate === undefined) {
        setStartDateError('You must specify a value for this required field.')
        errorCount++
      }
      if (endingDate === undefined) {
        setEndDateError('You must specify a value for this required field.')
        errorCount++
      }

      if (startingDate !== undefined && currentDate !== undefined && startingDate < currentDate) {
        setEndDateError('Start Date cannot be less than today.')
        errorCount++
      }
      if (startingDate !== undefined && endingDate !== undefined && startingDate > endingDate) {
        setEndDateError('End Date cannot be less than Start Date.')
        errorCount++
      }
      if (startingDate === endingDate) {
        const eventHoursStartID: any = eventHoursList.find(
          (item) => item.value === eventHoursStart
        )?.ID
        const eventHoursEndID: any = eventHoursList.find((item) => item.value === eventHoursEnd)?.ID
        const eventMinutesStartID: any = eventMinutesList.find(
          (item) => item.value === eventMinutesStart
        )?.ID
        const eventMinutesEndID: any = eventMinutesList.find(
          (item) => item.value === eventMinutesEnd
        )?.ID
        if (
          eventHoursStartID > eventHoursEndID ||
          (eventHoursEndID === eventHoursStartID && eventMinutesStartID > eventMinutesEndID)
        ) {
          setEndDateError('Start Time cannot be greater than End Time.')
          errorCount++
        } else if (
          eventHoursEndID === eventHoursStartID &&
          eventMinutesEndID === eventMinutesStartID
        ) {
          setEndDateError('Start Time and End Time cannot be the same.')
          errorCount++
        }
      }
    } else {
      rruleErrorCheck()
    }
    if (calendarEvent.Category === 'Select' || calendarEvent.Category === '') {
      setEventCategoryError(true)
      errorCount++
    }
    if (calendarEvent.Category === '' && eventCategory === 'specifyOwnValue') {
      setSpecifyOwnValue('Please specify category')
      errorCount++
    }
  }
  const rruleErrorCheck = () => {
    if (recurrence) {
      switch (rrule.freq) {
        case 'daily':
          rruleDayErrorCheck()
          break
        case 'weekly':
          rruleWeekErrorCheck()
          break
        case 'monthly':
          rruleMonthErrorCheck()
          break
        case 'yearly':
          rruleYearErrorCheck()
          break
        default:
          break
      }
      if (validateRangeOfReoccurrence(rrule)) {
        setRangeError('Please select start and end date for range of recurrence.')
        errorCount++
      } else if (rrule?.until?.split('T')[0] === 'null' && rrule?.isNoEndDate) {
        const today = new Date()
        today.setFullYear(today.getFullYear() + 10)
        rrule.until = today.toISOString().split('T')[0]
      } else {
        setRangeError('')
      }
    }
  }
  const validateRangeOfReoccurrence = (rrule): boolean => {
    const { count, dtstart, endRadioSelection, until } = rrule
    const isInvalidDate = (date) => date === 'nullT00:00:00' || date === 'T00:00:00'
    const isInvalidCount = (value) => value === '' || value === 0

    const invalidStartDate = isInvalidDate(dtstart)
    const invalidCount = isInvalidCount(count)
    const invalidValidEndDate = isInvalidDate(until)

    let inValid = true

    if (invalidStartDate && endRadioSelection === null) {
      inValid = true
    }else if (!invalidStartDate && endRadioSelection !== null) {
      if (endRadioSelection === 'noEndDate') {
        inValid = false
      }else if (endRadioSelection === 'endAfterCount') {
        inValid = invalidCount
      }else if (endRadioSelection === 'endBy') {
        inValid = invalidValidEndDate
      }
    }

    return inValid
  }

  const rruleDayErrorCheck = () => {
    if (
      (rrule.interval === null || rrule.interval === undefined) &&
      (!rrule.byweekday || !rrule?.byweekday[0]?.length)
    ) {
      setPatternError('Please enter daily frequency and try again.')
      errorCount++
    } else {
      setPatternError('')
    }
  }
  const rruleWeekErrorCheck = () => {
    if (
      rrule.interval === null ||
      rrule.interval === undefined ||
      !rrule.byweekday ||
      !rrule.byweekday[0].length
    ) {
      setPatternError('Please select days/frequency for weekly recurrence.')
      errorCount++
    } else {
      setPatternError('')
    }
  }
  const rruleMonthErrorCheck = () => {
    if (
      ((rrule.interval === null || rrule.interval === undefined) &&
        (rrule.bymonthday === null || rrule.bymonthday === undefined)) ||
      ((rrule.bysetpos === null || rrule.bysetpos === undefined) &&
        (!rrule.byweekday || !rrule.byweekday[0].length) &&
        (rrule.interval === null || rrule.interval === undefined))
    ) {
      setPatternError('Please enter day/frequency for the monthly recurring pattern.')
      errorCount++
    } else {
      setPatternError('')
    }
  }
  const rruleYearErrorCheck = () => {
    if (
      (rrule.interval === null || rrule.interval === undefined) &&
      (((rrule.bymonth === null || rrule.bymonth === undefined) &&
        (rrule.bymonthday === null || rrule.bymonthday === undefined)) ||
        ((rrule.bysetpos === null || rrule.bysetpos === undefined) &&
          (rrule.bymonth === null || rrule.bymonth === undefined)))
    ) {
      setPatternError('Please enter yearly frequency and try again.')
      errorCount++
    } else {
      setPatternError('')
    }
  }
  const saveCalendarEvent = async () => {
    validationCheck()
    if (errorCount === 0) {
      try {
        const tempCalendarEvent = { ...calendarEvent }
        if (tempCalendarEvent.ServicingOrganization === '')
          tempCalendarEvent.ServicingOrganization = 'All'
        if (
          tempCalendarEvent.AssignedComponentCode === -1 ||
          tempCalendarEvent.AssignedComponentCode === 'All'
        )
          tempCalendarEvent.AssignedComponentCode = null
        if (tempCalendarEvent.MAJCOMCode === -1) tempCalendarEvent.MAJCOMCode = null
        if (tempCalendarEvent.SectionCode === -1 || tempCalendarEvent.SectionCode === 'All')
          tempCalendarEvent.SectionCode = null
        if (tempCalendarEvent.RRule.freq === 'yearly' && tempCalendarEvent.RRule.interval === null)
          tempCalendarEvent.RRule.interval = 1

        const dtstart = new Date(tempCalendarEvent.RRule.dtstart)
        const dtstartUTC = new Date(dtstart).toISOString()
        const until = new Date(tempCalendarEvent.RRule.until)
        const untilUTC = new Date(until).toISOString()
        const userdetails = mpfRListsHttp().me()
        const userId = (await userdetails).userId

        // Assign the UTC value back to the calendarEvent.rrule.dtstart
        tempCalendarEvent.RRule.dtstart = dtstartUTC
        tempCalendarEvent.RRule.until = untilUTC

        tempCalendarEvent.RRule = JSON.stringify(tempCalendarEvent.RRule)
        tempCalendarEvent.ItemCreatedBy = userId
        tempCalendarEvent.ItemModifiedBy = userId

        const addList = await mpfRListsHttp().getList('CalendarEventsList')
        const data = await addList.addOrUpdateItem(tempCalendarEvent as IRListItem)
        const addedCalendarEvent = [...[data]]
        props.closeAfterSubmit()
        sendRefreshToParent()
      } catch (e) {
        console.error('Failed to save: ', e)
      }
    }
  }

  const cancelSaveEvent = () => {
    props.onClose()
    setExistingEvent(null)
  }
  const sendRefreshToParent = () => {
    props.sendRefresh()
  }
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const inputReference = useRef(null!)

  //** returns true if event is not a preset, own event category
  const isOwnEvent = (event) => {
    const preSetEvents = eventCategories.map((e) => e.label)
    return !preSetEvents.includes(event)
  }

  useEffect(() => {
    if (isAllDayEvent) {
      setEventHoursStart('T00:')
      setEventMinutesStart('00:00')
      setEventHoursEnd('T23:')
      setEventMinutesEnd('59:59')
    } else {
      setEventHoursStart('T00:')
      setEventHoursEnd('T00:')
    }
  }, [isAllDayEvent])
  useEffect(() => {
    if (isAllDayEvent) {
      setEventHoursStart('T00:')
      setEventMinutesStart('00:00')
      setEventHoursEnd('T23:')
      setEventMinutesEnd('59:59')
    }
    if (recurrence) {
      setRRuleTime({
        dtstartTime: eventHoursStart + eventMinutesStart,
        untilTime: eventHoursEnd + eventMinutesEnd,
      })
    } else {
      setOneTimeRule({
        dtstart: startingDate + eventHoursStart + eventMinutesStart,
        freq: 'daily',
        until: endingDate + eventHoursEnd + eventMinutesEnd,
      })
    }
  }, [
    endingDate,
    eventHoursEnd,
    eventHoursStart,
    eventMinutesEnd,
    eventMinutesStart,
    isAllDayEvent,
    recurrence,
    startingDate,
  ])

  useEffect(() => {
    const timeRule = recurrence ? rrule : oneTimeRule
    const startEventDate = timeRule?.dtstart
    const endEventDate = timeRule?.until
    const itemTime = new Date()

    setCalendarEvent({
      AssignedComponentCode: assignedcomponentValue,
      Category: eventCategoryFilter || ownCategoryValue,
      Description: eventDescription,
      EndDate: endEventDate,
      IsAllDayEvent: isAllDayEvent,
      IsArchived: false,
      ItemCreated: itemTime,
      ItemModified: itemTime,
      Location: eventLocation,
      MAJCOMCode: servicingmajcomValue,
      RRule: recurrence ? rrule : oneTimeRule,
      Recurrence: recurrence,
      SectionCode: sectionValue,
      ServicingOrganization: servicingOrganizationValue,
      StartDate: startEventDate,
      Title: eventTitle,
      eKey: props?.editEvent ? props.editEvent.id : '',
      eTag: props?.editEvent ? props.editEvent.etag : '',
    })
  }, [
    eventCategoryFilter,
    eventDescription,
    eventLocation,
    eventTitle,
    isAllDayEvent,
    oneTimeRule,
    ownCategoryValue,
    recurrence,
    rrule,
    servicingOrganizationValue,
    servicingmajcomValue,
    assignedcomponentValue,
    sectionValue,
  ])
  useEffect(() => {
    setCalendarList(props.calendarList)
  }, [props.calendarList])

  useEffect(() => {
    const today = new Date()
    const todaysHours = today.getHours() % 12 || 12
    if (startingDate === today.toISOString().split('T')[0]) {
      setFilteredHoursList(eventHoursList.filter((i) => i.ID > todaysHours))
    } else {
      setFilteredHoursList(eventHoursList)
    }
  }, [startingDate])

  useEffect(() => {
    setFiles([])
  }, [])

  useEffect(() => {
    if (props?.editEvent) {
      setExistingEvent(props?.editEvent)
      setActivateEdit(false)
    }
    if (
      props.editEvent &&
      props.editEvent.extendedProps &&
      props.editEvent.extendedProps.AttachmentFiles &&
      props.editEvent.extendedProps.AttachmentFiles.length > 0
    ) {
      const firstAttachment = props.editEvent.extendedProps.AttachmentFiles[0]
      setFiles([firstAttachment])
    }
  }, [props?.editEvent])
  useEffect(() => {
    //setting existing events in the inputs
    if (existingEvent) {
      setEventTitle(existingEvent.title)
      setEventLocation(existingEvent.extendedProps.Location)
      const eventRRule = JSON.parse(props?.eventRRule)
      const startDate = new Date(eventRRule?.dtstart)
      const untilDate = new Date(eventRRule?.until)
      const localTimeOffset = startDate.getTimezoneOffset()
      const adjustedStartDate = new Date(startDate.getTime() - localTimeOffset * 60000)
      const adjustedUntilDate = new Date(untilDate.getTime() - localTimeOffset * 60000)
      if (adjustedUntilDate < adjustedStartDate) {
        adjustedUntilDate.setDate(adjustedStartDate.getDate() - 1)
      }
      const formattedStartDate = adjustedStartDate.toISOString().split('T')[0]
      const formattedUntilDate = adjustedUntilDate.toISOString().split('T')[0]

      const startHours = startDate.getHours()
      const formattedStartHours = startHours < 10 ? `0${startHours}` : `${startHours}`
      setEventHoursStart(`T${formattedStartHours}:`)

      const startMinutes = startDate.getMinutes()
      const formattedStartMinutes = startMinutes < 10 ? `0${startMinutes}:00` : `${startMinutes}:00`
      setEventMinutesStart(formattedStartMinutes)

      const endHours = untilDate.getHours()
      const formattedEndHours = endHours < 10 ? `0${endHours}` : `${endHours}`
      setEventHoursEnd(`T${formattedEndHours}:`)

      const endMinutes = untilDate.getMinutes()
      const formattedEndMinutes = endMinutes < 10 ? `0${endMinutes}:00` : `${endMinutes}:00`
      setEventMinutesEnd(formattedEndMinutes)

      if (isRecurringEvent(props?.eventRRule)) {
        setRecurrence(true)
      } else {
        setRecurrence(false)
        setStartingDate(formattedStartDate)
        setEndingDate(formattedUntilDate)
      }
      setassignedcomponentValue(existingEvent.extendedProps.AssignedComponent)
      setMajcomOptions(findMAJCOM(metadataContext, existingEvent.extendedProps.AssignedComponent))

      setservicingmajcomValue(existingEvent.extendedProps?.MAJCOMCode)
      // const orgOptions = findOrg(metadataContext, 'AETC')
      // setServicingOrganizationOptions(orgOptions)
      setservicingOrganizationValue(existingEvent.extendedProps.ServicingOrganization)

      setOwnCategoryValue(
        isOwnEvent(existingEvent.extendedProps.Category) ? existingEvent.extendedProps.Category : ''
      )

      setsectionValue(existingEvent.extendedProps.SectionCode)
      setIsAllDayEvent(existingEvent.extendedProps.IsAllDayEvent)
      setEventDescrtiption(existingEvent.description)
      setEventCategoryFilter(existingEvent.extendedProps.Category)
    }
  }, [existingEvent, props?.eventRRule])

  useEffect(() => {
    inputReference.current.focus()
    props.userAssignComponent.length === 1
      ? setassignedcomponentValue(props.userAssignComponent[0].value)
      : setassignedcomponentValue(ALL_SELECT_VALUE)
    props.userMAJCOM.length === 1
      ? setservicingmajcomValue(props.userMAJCOM[0].value)
      : props.userMAJCOM.length === 0 && props.userAssignComponent.length === 1
      ? changeAssignedComponent(props.userAssignComponent[0])
      : setservicingmajcomValue(ALL_SELECT_VALUE)
    props.userSections.length === 1
      ? setsectionValue(props.userSections[0].value)
      : setsectionValue(ALL_SELECT_VALUE)
    if (props.userServicingOrganization?.length === 1) {
      setservicingOrganizationValue(props.userServicingOrganization[0].value)
    } else {
      setservicingOrganizationValue(SELECT_LABEL)
    }
  }, [])
  useEffect(() => {
    if (majcomOptions.length && majcomOptions.length === 1) {
      setservicingmajcomValue(majcomOptions[0].value)
      setServicingMAJCOMError(false)
    } else {
      setservicingmajcomValue(existingEvent ? existingEvent?.MAJCOMCode : 'SELECT_LABEL')
    }
  }, [majcomOptions])

  return (
    <>
      <div className='eventPopupHeader d-flex align-items-center p-3'>
        <h4
          aria-label='Add Calendar Event'
          className='color-primary poppins-semibold font-13'
          tabIndex={0}
        >
          {props?.editEvent ? 'Edit Calendar Event' : 'Add Calendar Event'}
          {!activateEdit && <a 
          className='Eventedit' 
          href='#' 
          onClick={(e) => {
            e.preventDefault()
            setActivateEdit(true)
          }}
          title='Edit'>
            <span className='icon-pencil'></span>
          </a>}
        </h4>

        <button
          aria-label='Close'
          className='closeEventPopup no-border whitebg font-10 cursor color-primary'
          onClick={cancelSaveEvent}
          title='Close'
        >
          <span className='icon-close'></span>
        </button>
      </div>
      <div className='popup-body'>
        <div className='formInputRow'>
          <div className='col-lg-3 col-sm-12'>
            <label htmlFor='event-title'>
              Title
              <span className='required'>*</span>
              <span className='tool-tip tooltip-right font-12 sourcesanspro' data-tip='Title'>
                <span className='icon-info color-primary font-13 ps-1'></span>
              </span>
            </label>
          </div>
          <div className='col-lg-9 col-sm-12'>
            <div className='inputWidth'>
              <input
                aria-label='Title'
                aria-required='true'
                className='input'
                disabled={!activateEdit}
                id='event-title'
                maxLength={255}
                onChange={titleInputHandler}
                placeholder='Enter Title'
                ref={inputReference}
                type='text'
                value={eventTitle}
              />

              <p className='required'>{titleError}</p>
            </div>
          </div>
        </div>

        <div className='formInputRow'>
          <div className='col-lg-3 col-sm-12'>
            <label htmlFor='event-location'>Location</label>
            <span className='tool-tip tooltip-right font-12 sourcesanspro' data-tip='Location'>
              <span className='icon-info color-primary font-13 ps-1'></span>
            </span>
          </div>
          <div className='col-lg-9 col-sm-12'>
            <div className='inputWidth'>
              <input
                aria-label='Location'
                className='input'
                disabled={!activateEdit}
                id='event-location'
                maxLength={255}
                onChange={locationInputHandler}
                placeholder='Enter Location'
                type='text'
                value={eventLocation}
              />
            </div>
          </div>
        </div>

        <div className='formInputRow'>
          <div className='col-lg-3 col-sm-12'>
            <label htmlFor='start-time'>
              Start Time
              {!recurrence && <span className='required'>*</span>}
              <span className='tool-tip tooltip-right font-12 sourcesanspro' data-tip='Start Time'>
                <span className='icon-info color-primary font-13 ps-1'></span>
              </span>
            </label>
          </div>
          <div className='col-lg-9 col-sm-12'>
            <div className='inputWidth'>
              {!recurrence && (
                <input
                  aria-label='Start Date'
                  className='inputDate'
                  disabled={!activateEdit}
                  id='start-time'
                  max='2999-12-31'
                  min={todayDate}
                  onChange={startDateSelectHandler}
                  placeholder='MM/DD/YYYY'
                  type='date'
                  value={startingDate}
                />
              )}
              <select
                aria-label='Time'
                className='inputDate'
                disabled={!activateEdit}
                id='selectHoursStart'
                onChange={hoursStartChangeHandler}
                value={eventHoursStart}
              >
                {eventHoursOptions}
              </select>
              :&nbsp;
              <select
                aria-label='Seconds'
                className='inputDate'
                disabled={!activateEdit}
                id='selectMinutesStart'
                onChange={minutesStartChangeHandler}
                value={eventMinutesStart}
              >
                {eventMinuteOptions}
              </select>
              {!recurrence && <p className='required'>{startDateError}</p>}
            </div>
          </div>
        </div>
        <div className='formInputRow'>
          <div className='col-sm-3'>
            <label htmlFor='end-time'>
              End Time
              {!recurrence && <span className='required'>*</span>}
              <span className='tool-tip tooltip-right font-12 sourcesanspro' data-tip='End Time'>
                <span className='icon-info color-primary font-13 ps-1'></span>
              </span>
            </label>
          </div>
          <div className='col-sm-9'>
            <div className='inputWidth'>
              {!recurrence && (
                <input
                  aria-label='End Date'
                  className='inputDate'
                  disabled={!activateEdit}
                  id='end-time'
                  max='2999-12-31'
                  min={todayDate}
                  onChange={endDateSelectHandler}
                  placeholder='MM/DD/YYYY'
                  type='date'
                  value={endingDate}
                />
              )}
              <select
                aria-label='Time'
                className='inputDate'
                disabled={!activateEdit}
                id='selectHoursEnd'
                onChange={hoursEndChangeHandler}
                value={eventHoursEnd}
              >
                {eventHoursOptions}
              </select>
              :&nbsp;
              <select
                aria-label='Seconds'
                className='inputDate'
                disabled={!activateEdit}
                id='selectMinutesEnd'
                onChange={minutesEndChangeHandler}
                value={eventMinutesEnd}
              >
                {eventMinuteOptions}
              </select>
              {!recurrence && <p className='required'>{endDateError}</p>}
            </div>
          </div>
        </div>
        <div className='formInputRow d-none'>
          <div className='col-sm-3'>
            <label htmlFor='allDaySelect'>All Day Event</label>
          </div>
          <div className='col-sm-9'>
            <div className='inputWidth'>
              <div className='checkboxInput'>
                <input
                  aria-label='All Day Event'
                  checked={isAllDayEvent}
                  className='checkbox'
                  id='allDaySelect'
                  onChange={allDaySelectHandler}
                  type='checkbox'
                />
                <span>Make this an all-day event that doesn't start or end at a specific hour</span>
              </div>
            </div>
          </div>
        </div>

        <div className='formInputRow'>
          <div className='col-sm-3'>
            <label htmlFor='recurrenceSelect'>Recurrence</label>
          </div>
          <div className='col-sm-9'>
            <div className='inputWidth'>
              <div className='checkboxInput'>
                <input
                  checked={recurrence}
                  className='checkbox'
                  disabled={!activateEdit}
                  id='recurrenceSelect'
                  onChange={recurringEventHandler}
                  type='checkbox'
                />
                <span>Make this repeating event</span>
              </div>
            </div>
          </div>
        </div>

        {recurrence && (
          <RecurrencePattern
            activateEdit={activateEdit}
            eventRRule={props.eventRRule}
            getRRule={getRRule}
            isEdit={props.isEdit}
            patternError={patternError}
            rangeError={rangeError}
            rrule={rruleTime}
          />
        )}
        <div className='formInputRow'>
          <div className='col-sm-3'>
            <label htmlFor='event-description'>Description</label>
            <span className='tool-tip tooltip-right font-12 sourcesanspro' data-tip='Description'>
              <span className='icon-info color-primary font-13 ps-1'></span>
            </span>
          </div>
          <div className='col-sm-9'>
            <div className='inputWidth'>
              <textarea
                aria-label='Description'
                className='input'
                disabled={!activateEdit}
                id='event-description'
                onChange={descriptionHandler}
                placeholder='Enter Description'
                value={eventDescription}
              ></textarea>
            </div>
          </div>
        </div>

        <div className='formInputRow'>
          <div className='col-sm-3'>
            <label htmlFor='AssignedComponent '>
              Assigned Component
              <span
                className='tool-tip tooltip-right font-12 sourcesanspro'
                data-tip='Assigned Component'
              >
                <span className='icon-info color-primary font-13 ps-1'></span>
              </span>
            </label>
          </div>
          <div className='col-sm-9'>
            <div className='eventCategory'>
              <div className={['inputWidth', 'eventDropdown'].join('')}>
                <CustomSelect
                  className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
                  disabled={props.userAssignComponent.length === 1 || !activateEdit}
                  error={assignedCompError}
                  formClassName='form-vertical w-100'
                  id='AssignedComponent'
                  inputProps={{
                    className: 'mb-1 font-12 poppins-medium title-color',
                  }}
                  name='AssignedComponent'
                  onChange={changeAssignedComponent}
                  options={props.userAssignComponent}
                  value={assignedcomponentValue}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='formInputRow'>
          <div className='col-sm-3'>
            <label htmlFor='ServicingMAJCOM '>
              Servicing MAJCOM
              <span
                className='tool-tip tooltip-right font-12 sourcesanspro'
                data-tip='Servicing MAJCOM'
              >
                <span className='icon-info color-primary font-13 ps-1'></span>
              </span>
            </label>
          </div>
          <div className='col-sm-9'>
            <div className='eventCategory'>
              <div className={['inputWidth', 'eventDropdown'].join('')}>
                <CustomSelect
                  className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
                  disabled={true}
                  error={servicingMAJCOMError}
                  formClassName='form-vertical w-100'
                  id='ServicingMAJCOM'
                  inputProps={{
                    className: 'mb-1 font-12 poppins-medium title-color',
                  }}
                  name='ServicingMAJCOM'
                  options={majcomOptions}
                  value={servicingmajcomValue}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='formInputRow'>
          <div className='col-sm-3'>
            <label htmlFor='ServicingOrganization'>
              Servicing Organization
              <span
                className='tool-tip tooltip-right font-12 sourcesanspro'
                data-tip='Servicing Organization'
              >
                <span className='icon-info color-primary font-13 ps-1'></span>
              </span>
            </label>
          </div>
          <div className='col-sm-9'>
            <div className='eventCategory'>
              <div className={['inputWidth', 'eventDropdown'].join('')}>
                <CustomSelect
                  className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
                  disabled={true}
                  error={servicingOrgError}
                  formClassName='form-vertical w-100'
                  id='Servicing Organization'
                  inputProps={{
                    className: 'mb-1 font-12 poppins-medium title-color',
                  }}
                  name='Servicing Organization'
                  options={servicingOrganizationOptions}
                  value={servicingOrganizationValue}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='formInputRow'>
          <div className='col-sm-3'>
            <label htmlFor='Sections '>
              Sections
              <span className='tool-tip tooltip-right font-12 sourcesanspro' data-tip='Sections'>
                <span className='icon-info color-primary font-13 ps-1'></span>
              </span>
            </label>
          </div>
          <div className='col-sm-9'>
            <div className='eventCategory'>
              <div className={['inputWidth', 'eventDropdown'].join('')}>
                <CustomSelect
                  className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
                  disabled={props.userSections.length === 1 || !activateEdit}
                  error={sectionError}
                  formClassName='form-vertical w-100'
                  id='section'
                  inputProps={{
                    className: 'mb-1 font-12 poppins-medium title-color',
                  }}
                  name='section'
                  onChange={sectionChangeHandler}
                  options={props.userSections}
                  value={sectionValue}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='formInputRow'>
          <div className='col-sm-3'>
            <label htmlFor='EventCategory'>
              Event Category <span className='mandatory'>*</span>
              <span
                className='tool-tip tooltip-right font-12 sourcesanspro'
                data-tip='Event Category'
              >
                <span className='icon-info color-primary font-13 ps-1'></span>
              </span>
            </label>
          </div>
          <div className='col-sm-9'>
            <div className='eventCategory'>
              <div className={['inputWidth', 'eventDropdown'].join('')}>
                <input
                  aria-label='Event Category'
                  checked={eventCategory === 'selectEventCategory'}
                  disabled={!activateEdit}
                  name='eventCategoryGroup'
                  onChange={() => eventCategoryHandler(0)}
                  type='radio'
                />
                <CustomSelect
                  className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
                  disabled={eventCategory === 'specifyOwnValue' || !activateEdit}
                  error={eventCategoryError && eventCategory !== 'specifyOwnValue'}
                  formClassName='form-vertical w-100 ps-2'
                  id='Sub Category'
                  inputProps={{
                    className: 'mb-1 font-12 poppins-medium title-color',
                  }}
                  name='Sub Category'
                  onChange={eventCategoryChangeHandler}
                  options={eventCategoryOptions}
                  value={eventCategoryFilter}
                />
              </div>
              <div className='inputWidth mt-1'>
                <input
                  aria-label='Specify your own value'
                  checked={eventCategory === 'specifyOwnValue'}
                  disabled={!activateEdit}
                  name='eventCategoryGroup'
                  onChange={() => eventCategoryHandler(1)}
                  type='radio'
                />
                <span className='spanSpecify'>Specify your own value</span>
                <input
                  aria-label='Specify your own value'
                  className='input'
                  disabled={eventCategory !== 'specifyOwnValue' || !activateEdit}
                  id='specifyOwnValueInput'
                  onChange={specifyOwnValueHandler}
                  type='text'
                  value={ownCategoryValue}
                />
                <p className='required'>{specifyOwnValueError}</p>
              </div>
            </div>
          </div>
        </div>

        <div className='formInputRow'>
          {activateEdit && <FileUpload
            filesProps={{ files, setFiles }}
            hint='Upload the files which are in the .png, .jpeg, .xlsx, .txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen'
            hintClassName='color-primary'
            info='Attach file (s) '
            infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            isInfo
            label='Attach File(s)'
            note='Screenshots need to be saved locally before uploading into system.'
            noteClassName='color-primary'
            replaceFileProps={{ replaceFile, setReplaceFile }}
            setFileError={setFileError}
          />}
        </div>
      </div>

      <div className='divaddpopupbtns p-3'>
        <div className='d-flex justify-content-end list-unstyled'>
          {existingEvent && !activateEdit && (
            <div className='ps-2'>
              <Buttons
                aria-label='Delete'
                className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                icon='icon-delete font-11 pe-1'
                label='Delete'
                onClick={props.onDelete}
              />
            </div>
          )}
          {activateEdit && <div className='ps-2'>
            <Buttons
              aria-label='Save'
              className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
              icon='icon-save font-11 pe-1'
              label={existingEvent ? 'Update' : 'Save'}
              onClick={saveCalendarEvent}
            />
          </div>}
          <div className='ps-2'>
            <Buttons
              aria-label='Cancel'
              className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
              icon='icon-close color-primary font-9 pe-1'
              label='Cancel'
              onClick={cancelSaveEvent}
            />
          </div>
        </div>
      </div>

      <div className='inputWidth'>
        <p className='required'>{errorFixMessage}</p>
      </div>
    </>
  )
}
export default AddEventForm
